import { BaseComponent } from './../base/base.component';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-organization-quick-actions',
  template: require('./organization-quick-actions.component.html')
})
export class OrganizationQuickActionsComponent extends BaseComponent implements OnInit {
  
  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/organization-quick-actions/organization-quick-actions.component.ts